import styles from 'legacy/common/components/form/Form.module.scss';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormWrapper from 'legacy/auth/components/FormWrapper';
import PhoneForm from 'legacy/auth/components/legacy/PhoneForm';
import Wrapper from 'legacy/common/components/layout/BackgroundWrapper';
import SocialRegister from 'legacy/auth/components/legacy/SocialRegister';
import PhoneRegisterConfirmation from 'legacy/auth/components/legacy/PhoneRegisterConfirmation';

const PhoneRegister = () => {
  const { t } = useTranslation('auth');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [hasRequestedCode, setHasRequestedcode] = useState(false);

  if (hasRequestedCode) {
    return (
      <Wrapper>
        <FormWrapper
          title="Confirmation"
          subtitle="We sent a confirmation code on your phone number."
        >
          <PhoneRegisterConfirmation phoneNumber={phoneNumber} />
        </FormWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <FormWrapper>
        <PhoneForm
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          setHasRequestedcode={setHasRequestedcode}
        />
        <div className={styles.separator}>
          <span />
          <div>{t('common.or')}</div>
          <span />
        </div>

        <SocialRegister type="email" />
      </FormWrapper>
    </Wrapper>
  );
};

export default PhoneRegister;
